import { cn } from '@/utils/tailwind';

interface ToggleSwitchProps {
  isSelected: boolean;
  onChange: (next: boolean) => void;
  'aria-label'?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  isSelected,
  onChange,
  'aria-label': ariaLabel,
}) => {
  const toggle = () => onChange(!isSelected);

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isSelected}
      aria-label={ariaLabel}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        toggle();
      }}
      onPointerDown={e => e.stopPropagation()}
      onMouseDown={e => e.stopPropagation()}
      onKeyDown={e => {
        e.stopPropagation();
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
        }
      }}
      onKeyUp={e => {
        e.stopPropagation();
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          toggle();
        }
      }}
      className={cn(
        'relative inline-flex h-4 w-10 shrink-0 cursor-pointer items-center rounded-full transition-colors',
        'focus-visible:ring-brand-navy focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none',
        isSelected ? 'bg-brand-navy' : 'bg-grayscale-gray3',
      )}
    >
      <span
        className={cn(
          'inline-block size-5 transform rounded-full bg-white shadow ring-1 ring-black/5 transition-transform',
          isSelected ? 'translate-x-[22px]' : '-translate-x-0.5',
        )}
      />
    </button>
  );
};

export default ToggleSwitch;
